export interface IMapDomainIds {
  [key: number]: string;
}
export const MapDomainIds: IMapDomainIds = {
  1: 'Speed',
  2: 'Reasoning',
  3: 'Attention',
  4: 'Memory',
  101: 'Forgetfulness',
  102: 'Distractibility',
  103: 'FalseTriggering',
};
